import { Theme } from 'mewe/constants';

export const getMutualContactsText = (users, totalCount, theme) => {
  if (!users?.length || !Array.isArray(users)) return '';

  if (!totalCount) {
    totalCount = users.length;
  }

  // looks dummy to make it with plain "if"s but strings for translations have to
  // be like that in order to be properly extracted for translation

  if (users.length === 1) {
    switch (theme) {
      case Theme.GROUP:
        return __(`<strong>{userName}</strong> is member.`, { userName: users[0].name });
      case Theme.EVENT:
        return __(`<strong>{userName}</strong> is attending.`, { userName: users[0].name });
      case Theme.PAGE:
        return __(`<strong>{userName}</strong> is following.`, { userName: users[0].name });
    }
  } else if (users.length === 2) {
    switch (theme) {
      case Theme.GROUP:
        return __(`<strong>{userName}</strong> and <strong>{userName2}</strong> are members.`, {
          userName: users[0].name,
          userName2: users[1].name,
        });
      case Theme.EVENT:
        return __(`<strong>{userName}</strong> and <strong>{userName2}</strong> are attending.`, {
          userName: users[0].name,
          userName2: users[1].name,
        });
      case Theme.PAGE:
        return __(`<strong>{userName}</strong> and <strong>{userName2}</strong> are following.`, {
          userName: users[0].name,
          userName2: users[1].name,
        });
    }
  } else if (users.length > 2) {
    switch (theme) {
      case Theme.GROUP:
        return __(`<strong>{userName}</strong> and {count} others you follow are members.`, {
          userName: users[0].name,
          count: totalCount - 1,
        });
      case Theme.EVENT:
        return __(`<strong>{userName}</strong> and {count} others you follow are attending.`, {
          userName: users[0].name,
          count: totalCount - 1,
        });
      case Theme.PAGE:
        return __(`<strong>{userName}</strong> and {count} others you follow are following.`, {
          userName: users[0].name,
          count: totalCount - 1,
        });
    }
  }
};
